import {
  AccountCreated,
  Attributes,
  Funds,
  HelpBuildYourBusiness,
  IllustrationProps,
  ItemManagement,
  MagnifyingGlassNoResults,
  Modifiers,
  SIMCard,
  SomethingWentWrong,
  TapToPayIphone,
  useIsMobileResolution,
  UserAdded,
} from '@npco/zeller-design-system'

const IllustrationMap = {
  AccountCreated,
  Funds: ({ size }: IllustrationProps) => (
    <Funds size={size} variant="outlined-blue" alt="funds" />
  ),
  HelpBuildYourBusiness,
  ItemManagement,
  Items: ItemManagement,
  MagnifyingGlassNoResults,
  SimCard: SIMCard,
  SomethingWentWrong,
  TapToPayIphone,
  UserAdded,
  Attributes,
  Modifiers,
} as const

export type IllustrationName = keyof typeof IllustrationMap

export const useGetIllustrationFromName = (name: IllustrationName) => {
  const isMobile = useIsMobileResolution()
  const illustrationSize = isMobile ? 'medium' : 'large'

  return IllustrationMap[name]({
    size: illustrationSize,
  })
}
